import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { toast } from "sonner";
import { MessageSquare, Trash2, Star } from "lucide-react";

export default function FeedbackView({ token }) {
  const h = { headers: { Authorization: `Bearer ${token}` } };
  const [list, setList] = useState([]);
  const load = () => axios.get(`${API}/superadmin/feedback`, h).then(({ data }) => setList(data)).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const remove = async (id) => { try { await axios.delete(`${API}/superadmin/feedback/${id}`, h); load(); } catch { toast.error("Suppression impossible"); } };

  return (
    <div className="max-w-3xl space-y-6" data-testid="sa-feedback">
      <div>
        <h2 className="flex items-center gap-2 font-display text-xl font-bold text-white"><MessageSquare className="h-5 w-5 text-[#FF6A00]" />Feedback de résiliation</h2>
        <p className="mt-1 text-sm text-zinc-500">Retours laissés par les prestataires au moment de résilier leur abonnement.</p>
      </div>
      {list.length === 0 ? (
        <p className="rounded-xl border border-dashed border-zinc-800 p-8 text-center text-zinc-500" data-testid="sa-feedback-empty">Aucun feedback pour le moment.</p>
      ) : (
        <div className="space-y-2">
          {list.map((f) => (
            <div key={f.id} data-testid={`feedback-row-${f.id}`} className="flex items-start justify-between gap-3 rounded-xl border border-zinc-800 bg-zinc-900 p-4">
              <div className="min-w-0">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="font-medium text-white">{f.org_name || "—"}</span>
                  {f.reason && <span className="rounded-full bg-[#FF6A00]/15 px-2 py-0.5 text-xs font-medium text-[#FF6A00]">{f.reason}</span>}
                  {f.rating ? <span className="flex items-center gap-0.5 text-xs text-zinc-400">{Array.from({ length: f.rating }).map((_, i) => <Star key={i} className="h-3 w-3 fill-[#FF6A00] text-[#FF6A00]" />)}</span> : null}
                </div>
                {f.message && <p className="mt-1.5 whitespace-pre-wrap text-sm text-zinc-300">{f.message}</p>}
                <p className="mt-1 text-xs text-zinc-600">{f.user_email || ""}{f.user_email ? " · " : ""}{f.created_at ? new Date(f.created_at).toLocaleString("fr-FR") : ""}</p>
              </div>
              <button data-testid={`feedback-del-${f.id}`} onClick={() => remove(f.id)} className="shrink-0 rounded-full p-2 text-zinc-500 hover:bg-red-500/10 hover:text-red-400"><Trash2 className="h-4 w-4" /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
